import * as T from 'io-ts'
import { DateFromISOString } from 'io-ts-types'

export const CouponCodec = T.type({
  id: T.string,
  name: T.string,
  description: T.string,
  expiry: T.union([DateFromISOString, T.null]),
  redeemedOn: T.union([DateFromISOString, T.null]),
  redemptionStore: T.union([T.string, T.null]),
  redemptionCheckNumber: T.union([T.string, T.null]),
  redemptionSubtotal: T.union([T.number, T.null]),
  redemptionDiscount: T.union([T.number, T.null]),
  redemptionGuestCount: T.union([T.Int, T.null]),
})

export type Coupon = T.TypeOf<typeof CouponCodec>
